/* eslint-disable react/prop-types */

import GlobalTitle from "../shared/GlobalTitle";
import RoundedButton from "../ui/RoundedButton";

const PoliciesCompliance = ({ data }) => {
  return (
    <div className="lg:pl-8">
      <GlobalTitle title={data.title} />
      <p className="pb-5 lg:pb-10">{data.description}</p>
      <div className="grid gap-10 md:grid-cols-2">
        <RoundedButton
          href="/terms-and-condition"
          className="w-full text-black sm:w-44 md:w-52"
        >
          Terms & Conditions
        </RoundedButton>
        <RoundedButton
          href="/grading-system"
          className="w-full text-black sm:w-44 md:w-52"
        >
          Grading System
        </RoundedButton>
      </div>
    </div>
  );
};

export default PoliciesCompliance;
